import { type TypeDiagnoseRunQuery, begatewayDiagnoseApi } from '@/store/api/begateway/begateway.diagnose.api';
import type { TypeAppDispatch, TypeRootState } from '@/store/store';
import type { TypeDiagnoseRun } from '@/types/begateway/types.begateway.diagnose';

const runMatches = (run: TypeDiagnoseRun, query: TypeDiagnoseRunQuery): boolean =>
    (!query.target || run.request.target === query.target) && (query.state === 'all' || run.outcome.state === query.state);

export const writeDiagnoseRun = (dispatch: TypeAppDispatch, run: TypeDiagnoseRun) => {
    if (!run?.id || !run.request) return;
    dispatch((inner: TypeAppDispatch, getState: () => TypeRootState) => {
        for (const args of begatewayDiagnoseApi.util.selectCachedArgsForQuery(getState(), 'listDiagnoseRuns')) {
            inner(begatewayDiagnoseApi.util.updateQueryData('listDiagnoseRuns', args, (draft) => {
                if (!draft.pages.length || !runMatches(run, args)) return;
                if (draft.pages.some((page) => page.items.some((item) => item.id === run.id))) return;
                draft.pages[0].items.unshift({ ...run, detailed: false });
            }));
        }
    });
};

export const dropDiagnoseRun = (dispatch: TypeAppDispatch, id: string) => {
    dispatch((inner: TypeAppDispatch, getState: () => TypeRootState) => {
        for (const args of begatewayDiagnoseApi.util.selectCachedArgsForQuery(getState(), 'listDiagnoseRuns')) {
            inner(begatewayDiagnoseApi.util.updateQueryData('listDiagnoseRuns', args, (draft) => {
                for (const page of draft.pages) page.items = page.items.filter((item) => item.id !== id);
            }));
        }
        inner(begatewayDiagnoseApi.util.invalidateTags([{ type: 'GatewayDiagnose', id }]));
    });
};
